import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;
 
  // @media (min-width: 576px) {
  //   max-width: 540px;
  // }

  @media (min-width: 768px) {
    max-width: 720px;
  }

  @media (min-width: 992px) {
    max-width: 960px;
  }
`;

export const AccesiblityText = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
